import { render, staticRenderFns } from "./WSelect.vue?vue&type=template&id=63c49952&scoped=true"
import script from "./WSelect.vue?vue&type=script&lang=js"
export * from "./WSelect.vue?vue&type=script&lang=js"
import style0 from "./WSelect.vue?vue&type=style&index=0&id=63c49952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c49952",
  null
  
)

export default component.exports